module.exports = __webpack_public_path__ + "img/melissa-list-sessao.9dcfe9ec.png";